export default {
  "print":{
    "paper":{
      "sizes":{
        "8x8":14.99,
        "10x8":17.99,
        "8x10":17.99,
        "14x11":24.99,
        "11x14":24.99,
        "18x12":29.99,
        "12x18":29.99,
        "20x16":34.99,
        "16x20":34.99
      }
    }
  },
  "calendar": {
    "sizes": {
      "8.5x11":24.99
    }
  }
}